import React from 'react'

const ConnectorCardSkeleton = () => {
    return (
        <div className="nav-link mb-2 connectortab connector-card-skeleton">
            <div className="connector-card-body">
                <div className="connector-card-header">
                    <div className="skeleton-block skeleton-icons"></div>
                    <div className="skeleton-block skeleton-title"></div>
                </div>
                <div className="connector-card-divider"></div>
                <div className="connector-meta-row">
                    <div className="skeleton-block skeleton-meta"></div>
                    <div className="skeleton-block skeleton-meta"></div>
                    <div className="skeleton-block skeleton-meta"></div>
                </div>
            </div>
        </div>
    )
}

export default ConnectorCardSkeleton
